import React, {useMemo} from 'react';
import {PromocodesSchema} from "@/views/Admin/Events/Event/Promocodes/Promocodes.schema";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";
import {Button} from 'uikit';
import styles from './Tabs.module.scss'
import {TabsPropsInterface} from './Tabs.props.interface';
import {useLocation} from 'react-router';

const Tabs = ({data, onChange}: TabsPropsInterface) => {
    const {promocodes, groups} = data
    const {query, set} = useQueryRouter();
    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const tabs = data.tabs
    const content = tabs.includes(params.get('content') as string) ? params.get('content') : 'promocodes';

    const handleTab = (content) => {
        set({
            ...query,
            page: {
                number: PromocodesSchema.promocodes.meta.currentPage,
                size: PromocodesSchema.promocodes.meta.perPage,
            },
            filter: {},
            sort: null,
            content,
        })

        onChange(prev => ({
            ...prev,
            isLoading: true,
            promocodes: {
                ...prev.promocodes,
                data: prev.promocodes.data.map(p => ({...p, isActive: false}))
            },
            groups: {
                ...prev.groups,
                data: prev.groups.data.map(p => ({...p, isActive: false}))
            },
            [content]: {
                ...prev[content],
                isLoading: true,
            }
        }))
    }

    return (
        <div className={styles.container}>
            <Button
                type={'tertiary'}
                size={'small'}
                style={{pointerEvents: content === 'promocodes' ? 'none' : 'all'}}
                theme={content === 'promocodes' ? 'default' : 'outline'}
                isActive={content === 'promocodes'}
                disabled={promocodes.isLoading}
                onClick={() => handleTab('promocodes')}>
                Промокоды
                {Boolean(promocodes.meta.total)}
            </Button>
            <Button
                type={'tertiary'}
                size={'small'}
                style={{pointerEvents: content === 'groups' ? 'none' : 'all'}}
                theme={content === 'groups' ? 'default' : 'outline'}
                isActive={content === 'groups'}
                disabled={groups.isLoading}
                onClick={() => handleTab('groups')}>
                Группы промокодов
                {Boolean(groups.meta.total)}
            </Button>
        </div>
    );
};

export default Tabs;
